module.exports = __webpack_public_path__ + "6ecb99ef9eabc843b43bf4969f9e81e2.svg";